// extracted by mini-css-extract-plugin
export var root = "opcNfRmXuGxs8lPXeoLd";